import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ContentWrapper, Tabs, TabPanel } from 'components';
import { CommunitiesList, MatrixList } from './components';
import { getCommunities } from 'store/selectors/communities';
import { getAuthUser } from 'store/selectors/auth';

import { Layout, Heading } from './styled';

const PROFILE_COMMUNITIES_HASH_TAB_MAP = { '#matrix': 1 };

const UserProfileCommunities = () => {
  const { t } = useTranslation();
  const communities = useSelector(getCommunities);
  const profile = useSelector(getAuthUser);

  return (
    <ContentWrapper minHeight="none">
      <Layout>
        <Layout.Header>
          <Heading>{t('profile.myCommunities')}</Heading>
        </Layout.Header>
        <Tabs
          variant="navigation"
          navigationLayout="panel"
          hashTabMap={PROFILE_COMMUNITIES_HASH_TAB_MAP}
        >
          <TabPanel label={t('common.overview')} index={0}>
            <Layout.Inner>
              <Layout.Table>
                <Layout.Title>{t('communitySettings.owner')}</Layout.Title>
                <CommunitiesList
                  data={communities.filter(
                    (item) => profile?.userId === item.communityOwner.userId,
                  )}
                  userId={profile.userId}
                  withDelete={true}
                  emptyStateType="owner"
                />
              </Layout.Table>
              <Layout.Table>
                <Layout.Title>{t('communitySettings.member')}</Layout.Title>
                <CommunitiesList
                  data={communities.filter(
                    (item) => profile?.userId !== item.communityOwner.userId,
                  )}
                  userId={profile.userId}
                  withLeave={true}
                  emptyStateType="member"
                />
              </Layout.Table>
            </Layout.Inner>
          </TabPanel>
          <TabPanel label="Matrix" index={1}>
            <MatrixList />
          </TabPanel>
        </Tabs>
      </Layout>
    </ContentWrapper>
  );
};

export default UserProfileCommunities;
